// extracted by mini-css-extract-plugin
module.exports = {"container":"AgainstCorruption_container__1iR0Z","text":"AgainstCorruption_text__3CRAu"};